export default {
  contractL1: '0x15874d65e649880c2614e7a480cb7c9a55787ff6',
  contractL2: '0x123389c2f0e9194d9ba98c21e63c375b67614108',
  pairL1: ['0xb6ca52c7916ad7960c12dc489fd93e5af7ca257f'],
  pairL2: ['0x9c5397dbcd8b039c5fc8b1bc2602fa2767567149'],
};
